// SPDX-License-Identifier: GPL-3.0-or-later
//
// Typst CV template. {{var}} = Typst-escaped substitution. {{{var}}} = raw
// (used for URLs). {{#section}}…{{/section}} = iterate array.

export const cvTemplate = String.raw`#set page(paper: "a4", margin: 2cm)
#set text(font: "Libertinus Serif", size: 11pt)
#show heading.where(level: 1): it => {
  block(below: 6pt)[
    #upper(text(weight: "bold", size: 12pt)[#it.body])
    #line(length: 100%, stroke: 0.5pt)
  ]
}
#set list(indent: 1em, spacing: 4pt)
#set par(justify: false, leading: 0.65em)

#align(center)[
  #text(size: 22pt, weight: "bold")[{{fullName}}] \
  {{contact.email}}{{#contact.phone}} #sym.dot.c {{contact.phone}}{{/contact.phone}}{{#contact.location}} #sym.dot.c {{contact.location}}{{/contact.location}}
  {{#contact.links}} \ {{label}}: #link("{{{url}}}"){{/contact.links}}
]

#v(0.5em)

= Summary

{{summary}}

= Experience

{{#experience}}
*{{role}}* #h(1fr) {{period}} \
_{{company}}_

{{#bullets}}
- {{.}}
{{/bullets}}
{{/experience}}

= Education

{{#education}}
*{{degree}}*, {{school}} #h(1fr) {{period}}{{#notes}} \
{{notes}}{{/notes}}

{{/education}}

= Skills

{{#skills}}
*{{category}}*: {{items}} \
{{/skills}}
`;
